import { z } from "zod";

import { insuranceSchema } from "../insurances";
import { stateSchema } from "../states";
import { PATIENT_STATUS } from "./constants";

export const patientScreeningSchema = z.object({
  state: stateSchema,
  insurance: insuranceSchema.nullable(),
  email: z.string().email(),
  patientType: z.enum(PATIENT_STATUS).nullable(),
  answers: z.object({
    insuranceNotListed: z.boolean().optional().nullable(),
    insuranceFreeText: z.string().optional().nullable(),
  }),
});
